import React from 'react';
import CardFactory from './CardFactory';

const Board = () => {
  return (
    <div>
      <CardFactory />
    </div>
  );
};

export default Board;
